import { Component, OnDestroy, OnInit } from '@angular/core';
import { PanelBarExpandMode } from '@progress/kendo-angular-layout';
import { CommonService } from "app/reusable/common.service";
import { combineLatest, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from "environments/environment";

@Component({
  selector: 'app-help-plans-types-overview-content',
  templateUrl: './help-plans-types-overview-content.component.html',
  styleUrls: ['./help-plans-types-overview-content.component.scss']
})
export class HelpPlansTypesOverviewContentComponent  implements OnInit, OnDestroy {
  helpPlanTypesList= [];
  helpPlansList = [];
  claimsReserveTypesList = [];
  public expandMode: number = PanelBarExpandMode.Single;
  public AlphaURL : string = environment.Services.AlphaURLSlot1;
  private subject$ = new Subject(); 
  constructor(private commonService: CommonService) { }

  ngOnInit() { 
  let getHelpPlanTypesUrl: string = `HelpPlanType/GetClaimReserveByHelpPlanType`;
  let getHelpPlansUrl: string = `HelpPlan`;
    let helpPlanTypes$ = this.commonService.getData(getHelpPlanTypesUrl,  this.AlphaURL);
    let helpPlans$ = this.commonService.getData(getHelpPlansUrl,  this.AlphaURL);
    combineLatest(helpPlanTypes$, helpPlans$,).pipe(takeUntil(this.subject$))
    .subscribe((results: any) => {
      this.helpPlanTypesList = results[0];
      this.helpPlansList = results[1];
    });
  }

  updateHelpPlanType(helpPlanType,helpPlan,event){
    let updateHelpPlanTypeUrl = `HelpPlanType`;
    helpPlanType.helpPlans.forEach(el => {
      if(el.hplId == helpPlan.hplId){
        el.claimsReserveType = event ;
      }
    });
    let _helpPlanAssociationToModify = helpPlanType.helpPlanHelpPlanTypeAssociations.find(hpa => hpa.hptHelpPlanId == helpPlan.hplId && hpa.hptHelpPlanTypeId == helpPlanType.htyId);
    _helpPlanAssociationToModify.hptClaimsReserveType = event;
    _helpPlanAssociationToModify.hptClaimReserveTypeId = event.crtId ;
    helpPlanType.helpPlanHelpPlanTypeAssociations = [_helpPlanAssociationToModify] ; 
    this.commonService.update(updateHelpPlanTypeUrl, helpPlanType).pipe(takeUntil(this.subject$)).subscribe()
  }
  trackByKey(index,item){
    return item.key;
    }

  ngOnDestroy(): void {
    this.subject$.next();
    this.subject$.complete();
  }
}